import { LoginBaseComponent } from 'components';

export default function Page() {
    return (
        <div className="flex w-full h-full items-center justify-center">
            <LoginBaseComponent />
        </div>
    )
}